function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Selection } from 'office-ui-fabric-react';
export { Selection } from 'office-ui-fabric-react';

/* SelectionOpts type is replicated from the source because ConstructorParameters utility type
  doesn't support constructors of generic classes */

const UNLIMITED_SELECTION_SIZE = Number.MAX_SAFE_INTEGER;
export class BoundableSelection extends Selection {
  constructor(opts) {
    var _opts$maxSelectionSiz;
    super(...[_objectSpread(_objectSpread({}, opts), {}, {
      onSelectionChanged: () => {
        const maxSelectionExceeded = this.getSelectedCount() > this._maxSelectionSize;
        if (maxSelectionExceeded) {
          this._invokeIfExists(opts.onMaxSelectionExceeded);
          this._restorePreviousSelection();
          return;
        }
        this._previousSelection = [...this.getSelection()];
        this._invokeIfExists(opts.onSelectionChanged);
      }
    })]);
    _defineProperty(this, "_previousSelection", []);
    this._maxSelectionSize = (_opts$maxSelectionSiz = opts.maxSelectionSize) !== null && _opts$maxSelectionSiz !== void 0 ? _opts$maxSelectionSiz : UNLIMITED_SELECTION_SIZE;
  }
  toggleAllSelected() {
    if (this._maxSelectionSize === UNLIMITED_SELECTION_SIZE) {
      super.toggleAllSelected();
      return;
    }
    const selectableKeys = this._getSelectableKeys();
    if (selectableKeys.length) {
      this._selectKeys(selectableKeys);
    } else {
      this._unselectAll();
    }
  }
  _restorePreviousSelection() {
    const keysToSelect = this._getKeysForItems(this._previousSelection);
    const selectedKeys = this._getSelectedKeys();
    selectedKeys.forEach(e => super.setKeySelected(e, false, true));
    keysToSelect.forEach(e => super.setKeySelected(e, true, true));
    return;
  }
  _invokeIfExists(fn) {
    fn && fn();
  }
  _getSelectableKeys() {
    return this._getUnselectedItems().slice(0, this._maxSelectionSize - super.getSelectedCount());
  }
  _selectKeys(keys) {
    keys.forEach(key => super.setKeySelected(key, true, true));
  }
  _unselectAll() {
    this._unselectKeys(this._getSelectedKeys());
  }
  _getKeysForItems(items) {
    return items.map(i => super.getKey(i));
  }
  _getSelectedKeys() {
    return this._getKeysForItems(super.getSelection());
  }
  _unselectKeys(keys) {
    keys.forEach(key => super.setKeySelected(key, false, true));
  }
  _getUnselectedItems() {
    const selectedKeys = new Set(this._getSelectedKeys());
    return this._getKeysForItems(super.getItems()).filter(key => !selectedKeys.has(key));
  }
}